export namespace HeadersTerceros {
    export const HeadersMyPerfitMO = {
        Accept: "application/json",
        Authorization: "Bearer maggieokon-pdnXDKYUmeZS3g94R3jqtgs43sYmWOTx",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
    }
}